<template>
	<div>
		<div class="d-flex align-items-center mb-1">
            <span>板块：</span>
            <b-button size="sm" variant="link" class="p-0 ml-2" @click="openDetails">详细</b-button>
        </div>
		<div v-bind:key="plate.index" v-for="plate in plates">
			<b-badge class="m-1 float-left" style="cursor: pointer;" @click="openDetails(plate[0])" :variant="plate[2] > 0 ? 'danger' : (plate[2] < 0 ? 'success' : 'secondary')">
                {{plate[1]}} {{ plate[2] !== undefined ? Number(plate[2]).toFixed(2) + '%' : '' }}
            </b-badge>
		</div>
        <div class="clearfix"></div>
        <PlateDetailsSidebar :symbol_code="symbol_code" :symbol_name="symbol_name" ref="plateDetailsSidebar" />
	</div>
	
</template>

<script>
	import {
		request_zzquant
	} from "network/request.js"
    import PlateDetailsSidebar from './PlateDetailsSidebar.vue'

	export default {
		props: {
			symbol_code: String,
            symbol_name: String
		},
		computed: {

		},
		components: {
            PlateDetailsSidebar
		},
		watch: {
			symbol_code: 'refresh'
		},
		data() {
			return {
				plates:[]
			}
		},
		mounted() {
			this.refresh();
		},
		methods: {
            openDetails(plateCode = null) {
                // Check if it's a mouse event (when called from "详细" button click without args, it might be an event object)
                if (plateCode && typeof plateCode === 'object') {
                    plateCode = null;
                }
                this.$refs.plateDetailsSidebar.show(plateCode);
            },
			refresh() {
				if(!this.symbol_code) {
					this.plates = [];
					return;
				}
				request_zzquant({
					'url': 'open/stock/' + this.symbol_code+'/info/12'
				}).then(res=>{
					// console.log(res);
					let list = res['data']['data']['ListJX'];
                    if (list && list.length > 0) {
                        this.plates = list.sort((a, b) => (b[2] || 0) - (a[2] || 0));
                    } else {
                        this.plates = [];
                    }
				})
			}

		}
	}
</script>

<style>
</style>